<template>
  <div v-if="isInitial && isOptOutBdc && isNot1Click && isOptOutChoice">
    <a href="#" @click="triggerModal">{{$t('cancelOneClick.changeOffer')}}</a>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {HAS_1_CLICK_OPT_OUT} from '../store/mutations';
import {COOKIE_HAS_1_CLICK_OPT_OUT, ORDER_STEP_INITIAL, RECORD_TYPE_ID_SINGLE_PRODUCT} from "../constants";
import {mapGetters} from "vuex";

export default {
  name: 'modal-cancel-one-click',

  computed: {
    ...mapGetters([
      'previousChoice',
      'journeyConfig',
    ]),
    isOptOutBdc() {
      return this.journeyConfig.displayOptOut === true;
    },
    isNot1Click() {
      return !this.$cookies.get('ONECLICK_CONTEXT');
    },
    isOptOutChoice() {
      return this.previousChoice.recordTypeId === RECORD_TYPE_ID_SINGLE_PRODUCT || this.previousChoice.displayOptOut;
    },
    isInitial() {
      return this.previousChoice.type === ORDER_STEP_INITIAL;
    }
  },
  methods:{
    triggerModal() {
      Swal.fire({
        customClass : {
          confirmButton: 'cancel-one-click-swal2-btn',
          cancelButton: 'cancel-one-click-swal2-btn',
        },
        width: 600,
        html: `
          <div style="line-height: 0.5em">
            <label>
                <input type="radio" name="cancel-one-click-radio" class="swal2-radio" value="1">
                ${this.$t('cancelOneClick.cancelOneClickModalSentence1')}
            </label>
            <label>
                <input type="radio" name="cancel-one-click-radio" class="swal2-radio" value="1">
                ${this.$t('cancelOneClick.cancelOneClickModalSentence2')}
            </label>
            <label>
                <input type="radio" name="cancel-one-click-radio" class="swal2-radio" value="0">
                ${this.$t('cancelOneClick.cancelOneClickModalSentence3')}
            </label>
          </div>
        `,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('all.confirm'),
        cancelButtonText: this.$t('all.cancel'),
        confirmButtonColor: '#88838380',
        cancelButtonColor: '#88838380',
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: _ => {
          const selected = document.querySelector('input[name=cancel-one-click-radio]:checked');
          if (selected) {
            if(selected.value === '1')  {
              this.$store.commit(HAS_1_CLICK_OPT_OUT, true);
              this.$cookies.set(COOKIE_HAS_1_CLICK_OPT_OUT, '1');
            }
          } else {
            Swal.showValidationMessage(`${this.$t('cancelOneClick.errorMessage')}`);
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: this.$t('cancelOneClick.configSaved'),
          });
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// modal-cancel-one-click.vue?2448545e